import "./styles/App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Main from "./components/Main/Main";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    document.title = "Подбор теплоносителей | Водокомфорт";
  }, []);
  return (
    <div >
      <Header />
      <Main />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
